import { useState } from "react";
import {  CaretDownOutlined, WarningOutlined,LineChartOutlined } from "@ant-design/icons";
import {
     ArrowLeftOutlined, SwapOutlined
} from '@ant-design/icons';
import { DatePicker,} from 'antd';

import { useNavigate } from 'react-router-dom';
import {
    Card,
    Typography,
    
    Space,
} from "antd";
import { Select } from 'antd';
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Line,
    Tooltip,
    LineChart,
    ResponsiveContainer,
    
} from "recharts";
import back from '../assets/images/back.svg';

function TotalFlow() {
    
    const [defaultOption, setDefaultOption] = useState("Year");
    const { Option } = Select;
    const [parameterthree, setParameterthree] = useState(null);
    const [defaultOptionss, setDefaultOptionss] = useState("Category");
    const { RangePicker } = DatePicker;
    const navigate = useNavigate();
    const onchanges = (value, dateString) => {
    
    
    
    
        setParameterthree(dateString);
        console.log(parameterthree);
      };
   
    const data = [
        {
            key: '1',
            name: 'GPCOH',
            override: 'start:Feb 1,2019',

            tags: ['Leak Detected'],
            action: <WarningOutlined style={{ fontSize: '40px', color: '#f74257' }} />

        },
        {
            key: '2',
            name: 'GPCOH',
            override: 'start:Feb 1,2019',

            tags: ['Poor Sanitation'],
            action: <WarningOutlined style={{ fontSize: '40px', color: '#f74257' }} />
        },
        {
            key: '3',
            name: 'GPCOH',
            override: 'start:Feb 1,2019',

            tags: ['Contaminated water '],
            action: <WarningOutlined style={{ fontSize: '40px', color: '#f74257' }} />
        },
    ];

    const dataNew = [
        {
            name: "Jan",
            2020: 4000,
            2021: 2400,
        },
        {
            name: "Feb",
            2020: 3000,
            2021: 1398,
        },
        {
            name: "Mar",
            2020: 2000,
            2021: 9800,
        },
        {
            name: "Apr",
            2020: 2780,
            2021: 3908,
        },
        {
            name: "May",
            2020: 1890,
            2021: 4800,
        },
        {
            name: "Jun",
            2020: 2390,
            2021: 3800,
        },
        {
            name: "Jul",
            2020: 3490,
            2021: 4300,
        },
        {
            name: "Aug",
            2020: 3490,
            2021: 4300,
        },
        {
            name: "Sep",
            2020: 3490,
            2021: 4300,
        },
        {
            name: "Oct",
            2020: 3490,
            2021: 4300,
        },
        {
            name: "Nov",
            2020: 3490,
            2021: 4300,
        },
        {
            name: "Dec",
            2020: 3490,
            2021: 4300,
        }
    ];

   
    const onRedirection = (event) => {

        // history.push('/dashboard');
        // window.history.back();
        navigate(-1);
    }
    const onselectClicks = () => {
        navigate('/accountstats');
    }
    const onselectClick = () => {
        navigate('/account-table');
    }
    const onSelect = event => {
        if (event == "year")
          setDefaultOption("Year");
        else if (event == "month")
          setDefaultOption("Month");
        else if (event == "week")
          setDefaultOption("Week");
        else if (event == "quarter")
          setDefaultOption("Quarter");
        else if (event == "day")
          setDefaultOption("Day");
      };

    return (
        <>
            <Header />
            <Main>
                {/* <div className="d-flex justify-content-between align-items-center">
                    <h4 className="mb-0"><ArrowLeftOutlined onClick={onRedirection} />  Account Stats</h4>
                </div> */}
                <div className="d-flex align-items-center mb-4">
                        {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
                        <img src={back} alt="" style={{width:'10px', cursor: 'pointer'}} onClick={onRedirection}  />
                        <h3 className="mb-0 ms-3"> Account Stats</h3>
                        </div>
                

                <div className="bottom-layout">
                    {/* <div className="layout-content"> */}

                    <div class="container-fluid pb-4 px-0 flex-column">
                        <div class="row row-cols-3 g-3">

                            <div className="col-12">


                                <Card bordered={false} className="checkStatusHealth">
                                    <div className="fs-20 fw-bold d-flex gap-3 justify-content-between align-items-center flex-wrap">
                                        <div className='d-flex gap-3'>
                                            <div className="px-3 py-1 text-blue bg-white border border-info rounded align-self-center c-pointer"
                                            onClick={onselectClicks}
                                            >
                                             <LineChartOutlined className="pe-2" />   Plot
                                            </div>
                                            <div className="px-3 py-1 bg-white border rounded align-self-center c-pointer"
                                            onClick={onselectClick}
                                            > Table
                                            </div>
                                        </div>
                                        <div id="1st" className="col-12 col-lg-3 d-flex gap-2 dropdownCategories  selectCalender ms-auto" >
                                        <Select
                                        defaultValue="Year"
                                        style={{
                                            width: 120,
                                        }}

                                        bordered={false}
                                        onChange={onSelect}

                                        >
                                        <Option value="year">Year</Option>
                                        <Option value="month">Month</Option>
                                        <Option value="week">Week</Option>
                                        <Option value="quarter">Quarter</Option>
                                        <Option value="day">Day</Option>
                                        </Select>
                                        {defaultOptionss === "Account" ?
                                        <Space direction="horizontal" size={1}>
                                            {defaultOption === "Year" ?
                                            <DatePicker picker="year" onChange={onchanges}  separator={<SwapOutlined />} /> : ""}
                                            {defaultOption === "Month" ?
                                            <DatePicker picker="month" onChange={onchanges}  separator={<SwapOutlined />} /> : ""}
                                            {defaultOption === "Week" ?
                                            <DatePicker picker="week" onChange={onchanges}  separator={<SwapOutlined />} /> : ""}
                                            {defaultOption === "Quarter" ?
                                            <DatePicker picker="quarter" onChange={onchanges}  separator={<SwapOutlined />} /> : ""}
                                            {defaultOption === "Day" ?
                                            <DatePicker onChange={onchanges} /> : ""}
                                        </Space> :
                                        <Space direction="horizontal" size={1}>
                                            {defaultOption === "Year" ?
                                            <RangePicker picker="year" onChange={onchange}  separator={<SwapOutlined />} />  : ""}
                                            {defaultOption === "Month" ?
                                            <RangePicker picker="month" onChange={onchange}  separator={<SwapOutlined />} /> : ""}
                                            {defaultOption === "Week" ?
                                            <RangePicker picker="week" onChange={onchange}  separator={<SwapOutlined />} /> : ""}
                                            {defaultOption === "Quarter" ?
                                            <RangePicker picker="quarter" onChange={onchange}  separator={<SwapOutlined />} /> : ""}
                                            {defaultOption === "Day" ?
                                            <RangePicker onChange={onchange}  separator={<SwapOutlined />} /> : ""}
                                        </Space>}
                                    </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12 col-lg-12">
                                            <div style={{ maxWidth: "100%", margin: "0 auto", height: "500px" }} >
                                                <ResponsiveContainer>
                                                    <LineChart
                                                        data={dataNew}
                                                        margin={{ top: 25, right: 25, bottom: 25, left: 0 }}
                                                    >
                                                        <XAxis dataKey="name" />
                                                        <YAxis dataKey="2021" />
                                                        <Line type="monotone"
                                                            dataKey="2020"
                                                            isAnimationActive={false}
                                                            name="Repos"
                                                            fill="#43c6db"
                                                            stroke="#6699CC"
                                                        >
                                                            {/* <LabelList dataKey="y" position="top" offset={10} /> */}
                                                        </Line>
                                                        <Line type="monotone"
                                                            dataKey="2021"
                                                            isAnimationActive={false}
                                                            name="Repos"
                                                            fill="#488ac7"
                                                            stroke="#93ffe8"
                                                        >
                                                            {/* <LabelList dataKey="z" position="top" offset={10} /> */}
                                                        </Line>
                                                        <CartesianGrid stroke="lightGrey" />
                                                        <Tooltip />
                                                    </LineChart>

                                                </ResponsiveContainer>
                                                </div>
                                            </div>
                                    </div>

                                </Card>

                            </div>
                            <br />

                            {/* </div> */}
                        </div>
                    </div>
                </div>
                <br />
                
            </Main>
        </>
    );
}

export default TotalFlow;
